/* Enhance Prestige's desktop grid without changing its media order or mobile carousel. */
class CoaGalleryMosaic extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('scroll-carousel');
    if (!this.carousel) return;

    this.desktop = window.matchMedia('(min-width: 1000px)');
    this.schedule = () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.layout());
    };
    this.desktop.addEventListener('change', this.schedule);
    this.resizeObserver = new ResizeObserver(this.schedule);
    this.resizeObserver.observe(this.carousel);
    for (const cell of this.carousel.children) {
      if (cell.firstElementChild) this.resizeObserver.observe(cell.firstElementChild);
    }
    this.mutationObserver = new MutationObserver(this.schedule);
    this.mutationObserver.observe(this.carousel, {
      subtree: true, attributes: true, attributeFilter: ['hidden'],
    });
    this.schedule();
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.desktop?.removeEventListener('change', this.schedule);
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  layout() {
    if (!this.desktop.matches || !this.carousel.clientWidth) {
      this.removeAttribute('ready');
      return;
    }

    const cells = [...this.carousel.children].filter(cell => !cell.hidden);
    const highlighted = this.hasAttribute('highlight-first');
    const gap = parseFloat(getComputedStyle(this.carousel).columnGap) || 0;
    // Explicit columns preserve the highlighted image when variants hide media.
    cells.forEach((cell, index) => {
      cell.style.setProperty('--coa-media-column', highlighted && index === 0 ? '1 / -1' : '1');
    });
    this.setAttribute('ready', '');
    const heights = cells.map(cell => cell.firstElementChild?.getBoundingClientRect().height || 0);
    const bottom = [1, 1];

    cells.forEach((cell, index) => {
      const fullWidth = highlighted && index === 0;
      const column = bottom[0] <= bottom[1] ? 0 : 1;
      const start = fullWidth ? Math.max(...bottom) : bottom[column];
      const span = Math.max(1, Math.ceil(heights[index]));
      cell.style.setProperty('--coa-media-column', fullWidth ? '1 / -1' : String(column + 1));
      cell.style.setProperty('--coa-media-row', `${start} / span ${span}`);
      const next = start + span + Math.round(gap);
      if (fullWidth) bottom.fill(next);
      else bottom[column] = next;
    });
  }
}

if (!customElements.get('coa-gallery-mosaic')) {
  customElements.define('coa-gallery-mosaic', CoaGalleryMosaic);
}
